import { render, staticRenderFns } from "./MessageTip.vue?vue&type=template&id=77b5a84d&scoped=true&"
import script from "./MessageTip.vue?vue&type=script&lang=js&"
export * from "./MessageTip.vue?vue&type=script&lang=js&"
import style0 from "./MessageTip.vue?vue&type=style&index=0&id=77b5a84d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b5a84d",
  null
  
)

export default component.exports